class CartProductRecommendations extends HTMLElement {
  constructor(){
    super();
    this.generateRecommendations();
  }
  generateRecommendations(){
    const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
    if ( cartItems.length > 0 ) {
      fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=helper-cart-recommendations&product_id=${cartItems[0].dataset.productId}&limit=${this.getAttribute('data-limit')}`)
        .then(response => response.text())
        .then(text => {
          const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.cart-product-recommendations');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-recommended-item]').length > 0 ) {
            document.getElementById('cart-recommendations').innerHTML = innerHTML.innerHTML;
          }
        })
    }
  }
}
customElements.define('cart-product-recommendations', CartProductRecommendations);